import { useMemo } from 'react';
import { useAppSystem } from '../hooks/useAppSystem';
import { getInstalledAppBySlug, isAppInstalled } from '../lib/controlCentreApps';
import ControlCentreAcquisitionPanel from '../components/admin-dashboard/ControlCentreAcquisitionPanel';
import ControlCentreActivityLogShell from '../components/admin-dashboard/ControlCentreActivityLogShell';
import ControlCentreMarketingPanel from '../components/admin-dashboard/ControlCentreMarketingPanel';
import ControlCentreWelcomeBanner from '../components/admin-dashboard/ControlCentreWelcomeBanner';
import InventoryDashboardSnippet from '../components/admin-dashboard/InventoryDashboardSnippet';

// Parked off the Control Centre for now. Re-mount when we want them back:
// CalendarDashboardSnippet, CrmDashboardSnippet, InvoicesPanel,
// MarketingDashboardSnippet (the campaign calendar widget).

const INVENTORY_APP_SLUG = 'inventory';
const MARKETING_APP_SLUG = 'marketing';

/** Admin control centre widgets (performance, marketing, inventory). */
export default function ControlCentreDashboard() {
  const { coreApps, installedAddons, loading: appsLoading } = useAppSystem();

  const isInventoryInstalled = useMemo(
    () => isAppInstalled(INVENTORY_APP_SLUG, coreApps, installedAddons),
    [coreApps, installedAddons]
  );

  const inventoryApp = useMemo(
    () => getInstalledAppBySlug(INVENTORY_APP_SLUG, coreApps, installedAddons),
    [coreApps, installedAddons]
  );

  const isMarketingInstalled = useMemo(
    () => isAppInstalled(MARKETING_APP_SLUG, coreApps, installedAddons),
    [coreApps, installedAddons]
  );

  return (
    <ControlCentreActivityLogShell>
      <ControlCentreWelcomeBanner />
      <ControlCentreAcquisitionPanel />
      <ControlCentreMarketingPanel enabled={!appsLoading && isMarketingInstalled} />

      {appsLoading ? (
        <div className="flex items-center justify-center min-h-[200px] text-sm text-gray-500">
          Loading…
        </div>
      ) : (
        <div className="space-y-5 w-full">
          {isInventoryInstalled && inventoryApp ? (
            <InventoryDashboardSnippet app={inventoryApp} />
          ) : null}
        </div>
      )}
    </ControlCentreActivityLogShell>
  );
}
